import type { CalloutProps } from "@op/puck-types";
import { Dc_Text_Callout } from "@op/sf-op";

const Callout = ({ children, icon }: CalloutProps) => {
  return <Dc_Text_Callout text={children as string} icon={icon} />;
};

export default Callout;
